import { LinkButton } from "@/components/ui/Button";
import { Card } from "@/components/ui/Card";
import { Logo } from "@/components/ui/Logo";
import { PublicLayout } from "@/components/layout/PublicLayout";
import { TelegramLoginButton } from "@/components/auth/TelegramLoginButton";

export function LandingPage() {
  return (
    <PublicLayout>
      <div className="w-full max-w-[520px] text-center animate-fade-in">
        <Logo size="lg" showTagline />

        <Card padding="lg" className="mt-10 text-left sm:text-center">
          <h2 className="text-[28px] font-bold tracking-tight text-[#1a1a1a]">For Event Organizers</h2>
          <p className="mt-3 text-[15px] text-[#6c757d] sm:px-2">
            Help your participants find the right people to meet — through short video pitches and AI matching.
          </p>

          <div className="mt-8 flex flex-col gap-3">
            {/* Telegram is the fastest path — single tap, no email, and
                connecting it also wires up bot notifications about new
                matches from the same click. */}
            <div className="flex justify-center">
              <TelegramLoginButton />
            </div>

            <div className="my-1 flex items-center gap-3">
              <span className="h-px flex-1 bg-[#e2e8f0]" />
              <span className="text-[11px] font-semibold uppercase tracking-wider text-[#94a3b8]">
                or
              </span>
              <span className="h-px flex-1 bg-[#e2e8f0]" />
            </div>

            <LinkButton to="/sign-in" fullWidth>
              Sign In with Email
            </LinkButton>
            <p className="text-[13px] text-[#6c757d]">
              Don't have an account?{" "}
              <a
                href="/sign-up"
                className="font-semibold text-[#2563eb] hover:text-[#1d4ed8]"
              >
                Sign up
              </a>
            </p>
          </div>
        </Card>

        <p className="mt-8 text-[13px] text-[#94a3b8]">
          Are you a participant?{" "}
          <a href="/join" className="font-semibold text-[#2563eb] hover:text-[#1d4ed8]">
            Scan QR or enter via link
          </a>
        </p>
      </div>
    </PublicLayout>
  );
}
